import { ReducerBase } from 'common/reducer';
import initialState from 'app/initialState';
import { Unit, UnitConversionRate } from 'domain/unit';
import { UnitsConversionRatesLoaded, UnitsLoaded } from './units.actions';
import { MyCommodityUpdatedFromStream } from './commodities.actions';

export class UnitsReducer extends ReducerBase<Unit[]> {
	constructor() {
		super();
		this.addHandler(UnitsLoaded.EventName, this.handleUnitsLoaded);
	}

	handleUnitsLoaded(state: Unit[] = initialState.units, event: UnitsLoaded): Unit[] {
		return event.units;
	}

	handleDefault(state: Unit[] = initialState.units) {
		return state;
	}
}


export class UnitsConversionRatesReducer extends ReducerBase<UnitConversionRate[]> {
	constructor() {
		super();
		this.addHandler(UnitsConversionRatesLoaded.EventName, this.handleUnitsConversionRatesLoaded);
		this.addHandler(MyCommodityUpdatedFromStream.EventName, this.handleCommodityUpdatedFromStream);
	}

	handleCommodityUpdatedFromStream(state: UnitConversionRate[] = initialState.unitsConversionRates, event: MyCommodityUpdatedFromStream): UnitConversionRate[] {
		return state ? state.map(c => (c.commodityId === event.update.id && c.fromUnitId === event.update.baseUnit.id && 
					(event.update.localUnit?.id !== c.toUnitId || event.update.localUnit?.conversionRate !== c.conversionRate) ? { 
				...c, 
				toUnitId: event.update.localUnit?.id,
				conversionRate: event.update.localUnit?.conversionRate
			} : c)) : state;
	}

	handleUnitsConversionRatesLoaded(state: UnitConversionRate[] = initialState.unitsConversionRates, event: UnitsConversionRatesLoaded): UnitConversionRate[] {
		return event.unitsconversionRates;
	}

	handleDefault(state: UnitConversionRate[] = initialState.unitsConversionRates) {
		return state;
	}
}